/** Flutter parity: `app_time_store.dart` SharedPreferences keys. */
export const APP_TIME_ENABLED_KEY = 'app_time_enabled';
export const APP_TIME_MOCKED_UTC_MS_KEY = 'app_time_mocked_utc_ms';
export const APP_TIME_TIMEZONE_KEY = 'app_time_timezone';

export const DEVICE_LOCAL_TIMEZONE_OPTION_ID = '__device_local__';

export type MockTimeZoneOption = {
  id: string;
  label: string;
};

export const MOCK_TIME_ZONE_OPTIONS: MockTimeZoneOption[] = [
  { id: DEVICE_LOCAL_TIMEZONE_OPTION_ID, label: 'Device local timezone' },
  { id: 'UTC', label: 'UTC' },
  { id: 'America/Los_Angeles', label: 'US Pacific (America/Los_Angeles)' },
  { id: 'America/Denver', label: 'US Mountain (America/Denver)' },
  { id: 'America/Phoenix', label: 'US Arizona (America/Phoenix)' },
  { id: 'America/Chicago', label: 'US Central (America/Chicago)' },
  { id: 'America/New_York', label: 'US Eastern (America/New_York)' },
  { id: 'America/Anchorage', label: 'US Alaska (America/Anchorage)' },
  { id: 'Pacific/Honolulu', label: 'US Hawaii (Pacific/Honolulu)' },
  { id: 'Europe/London', label: 'Europe/London' },
  { id: 'Europe/Paris', label: 'Europe/Paris' },
  { id: 'Asia/Tokyo', label: 'Asia/Tokyo' },
  { id: 'Asia/Shanghai', label: 'Asia/Shanghai' },
  { id: 'Asia/Seoul', label: 'Asia/Seoul' },
  { id: 'Australia/Sydney', label: 'Australia/Sydney' },
];
